var map = {
	"./": 461,
	"./development": 1433,
	"./development.js": 1433,
	"./index": 461,
	"./index.js": 461,
	"./preprod": 1434,
	"./preprod.js": 1434,
	"./production": 1414,
	"./production.js": 1414,
	"./staging": 1435,
	"./staging.js": 1435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3443;